export class ManagementEntityDataDTO {
  /**
   * The unique identifier for the management entity.
   *
   */
  uuid: string;
  period: Date;

  constructor(uuid: string, period: Date) {
    this.uuid = uuid;
    this.period = period;
  }
}
